import { Alert, AntdList, Avatar, Button, Divider, Form, Icons, Input, SaveButton, Show, useForm } from "@pankod/refine-antd";
import { IResourceComponentsProps } from "@pankod/refine-core";
import { chatModel } from "interfaces";
import { useState } from "react";
import { OPENAI_LOGO_PATH, OPENAI_LOGO_PATH2 } from "scripts/site";
//const { Search } = Input;

export const BrainstormingList: React.FC<IResourceComponentsProps> = () => {
  const [chatData, setChatData] = useState<chatModel[]>([]);

  const { formProps, saveButtonProps, formLoading } = useForm({
    submitOnEnter: true,
    onMutationSuccess(data, variables, context) {
      setChatData(data?.data as chatModel[]);
    },
    onMutationError(error, variables, context) {
      setChatData([{
        actor: "GPT-4",
        conversation: {
          contextual: error?.statusCode + " - " + error?.response?.statusText + ": " + error?.response?.data?.message,
          standard: error?.statusCode + " - " + error?.response?.statusText + ": " + error?.response?.data?.message,
        },
        error: true
      }]);
    },

    redirect: false,
  });


  return (
    <Show
      canDelete={false}
      isLoading={formLoading}
      headerProps={{
        backIcon: false,
        title: "Brainstorming with GPT",
        extra: chatData.length > 0 && <Button danger icon={<Icons.ClearOutlined />} onClick={() => { setChatData([]) }}>Clear</Button>
      }}>

      <Alert message={
        <>Generate automated brainstorming discussions between two hypothetical characters, one talking pro and one against any given topic. Access detailed article
          <a target="_blank" rel="noopener noreferrer" href="https://aka.ms/tcs-helium/#/accelerators/article/show/ce93a1d0-246c-4a6e-a47a-e8ebcb2336ca"> here.</a>
        </>
      }
        type="info" showIcon={false} banner style={{ marginBottom: 20 }}></Alert>
      <Form {...formProps} layout="vertical" autoComplete="off"
        initialValues={{
          characterOption: "2"
        }}>
        <Form.Item label="Topic" name="topic"
          style={{ marginBottom: 40 }}
          rules={[{
            required: true,
            message: 'Please input a topic to brainstorm!',
          }]}>
          <Input placeholder="A topic to brainstorm!" />
        </Form.Item>
        <Form.Item
          hidden
          name="characterOption"
        >
          <Input />
        </Form.Item>
        <Form.Item>
          <SaveButton {...saveButtonProps} title="Send" icon={<Icons.SendOutlined />}>Send</SaveButton>
        </Form.Item>
      </Form>
      {chatData.length > 0 &&
        <>
          <Divider>Conversation</Divider>
          <div
            id="scrollableDiv"
            style={{
              maxHeight: 500,
              overflow: 'auto',
              marginBottom: 20,
              //padding: '0 16px',
              //border: '1px solid rgba(140, 140, 140, 0.35)',
            }}
          >
            <AntdList
              itemLayout="vertical"
              pagination={false}
              dataSource={chatData}
              renderItem={(item, index) => (
                <AntdList.Item style={{ border: "none" }}>
                  <AntdList.Item.Meta
                    avatar={<Avatar src={index % 2 === 0 ? OPENAI_LOGO_PATH : OPENAI_LOGO_PATH2} />}
                    title={item.actor}
                    description={item.conversation.standard} />
                </AntdList.Item>
              )}
            >
            </AntdList>
          </div>
        </>
      }

    </Show>
  );
};